class CardProductCS extends HTMLElement {
  constructor() {
    super();
    this.originalParent = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupListeners());
    } else {
      this.setupListeners();
    }
  }

  setupListeners() {
    const submitElements = this.querySelectorAll('.quick-add-custom__submit');
    const closeModelElements = document.querySelectorAll('.close-model');
    const closeCartDrawer = document.querySelector('cart-drawer .drawer__close');

    submitElements.forEach((submitElement) => {
      const submitElementCart = submitElement.closest('#product-slider-cart-drawer');

      if (submitElementCart) {
        submitElement.addEventListener('click', () => {
          setTimeout(() => {
            closeCartDrawer?.click();
          }, 1500);
        });
      }

      submitElement.addEventListener('click', () => this.handleSubmitClick(submitElement));
    });

    closeModelElements.forEach((closeModelElement) => {
      closeModelElement.addEventListener('click', () => this.handleCloseModelClick(closeModelElement));
    });
  }

  handleSubmitClick(submitElement) {
    const productUrl = submitElement.getAttribute('data-card-product-url');
    const cardWrapper = submitElement.closest('.card-wrapper');
    const cardSlide = cardWrapper.closest('.section-slide-items');
    let cardspinner = cardWrapper.querySelector('.quick-add-custom-spinner-mb');
    let cardspinnerDsk = cardWrapper.querySelector('.loading-overlay__spinner-dsk');
    let infoElement = cardWrapper.querySelector('.quick-add-custom__info-content');

    if (cardSlide) {
      cardspinnerDsk = cardSlide?.closest('.section-product-slide')?.querySelector('.loading-overlay__spinner-dsk');
    }

    if (cardSlide) {
      const elementBottom = cardSlide.getBoundingClientRect().bottom + window.scrollY;
      window.scrollTo({
        top: elementBottom - 200,
        behavior: 'smooth',
      });
    } else {
      cardWrapper.scrollIntoView({
        behavior: 'smooth',
      });
    }

    cardWrapper?.classList.add('open-quick-model');
    cardSlide?.classList.add('cart-slide-quick-open');
    cardSlide?.classList.add('is-quick-open');
    cardspinner?.classList.remove('hidden');
    cardspinnerDsk?.classList.remove('hidden');

    if (!infoElement && cardSlide) {
      infoElement = cardSlide.parentNode.querySelector('.quick-add-custom__info-content');
    }
    if (infoElement) {
      infoElement.innerHTML = '';
    }

    this.clearOtherInfoElements(infoElement);

    if (infoElement && !this.originalParent) {
      this.originalParent = infoElement.closest('.quick-add-custom__info').parentNode;
    }

    if (productUrl) {
      if (infoElement.innerHTML.trim() === '') {
        this.fetchProductInfo(productUrl, infoElement, cardWrapper, cardSlide, cardspinner, cardspinnerDsk);
      } else {
        this.resetInfoElement(infoElement, cardWrapper, cardSlide);
      }
    }
    if (infoElement) {
      infoElement.closest('.quick-add-custom__info')?.classList.remove('open-quick-add-slide');
    }
  }

  clearOtherInfoElements(currentInfoElement) {
    document.querySelectorAll('.quick-add-custom__info-content').forEach((otherInfoElement) => {
      if (otherInfoElement !== currentInfoElement) {
        otherInfoElement.innerHTML = '';
        otherInfoElement.closest('.quick-add-custom__info').setAttribute('style', '');
        otherInfoElement.closest('.quick-add-custom__info').classList.remove('open-quick-add-slide');
        if (otherInfoElement.closest('.product-card-wrapper')) {
          otherInfoElement.closest('.product-card-wrapper').setAttribute('style', '');
        } else {
          otherInfoElement.previousElementSibling
            .querySelectorAll('.product-card-wrapper')
            .forEach((otherInfoElementCard) => {
              otherInfoElementCard.setAttribute('style', '');
            });
        }
      }
    });
  }

  fetchProductInfo(
    productUrl,
    infoElement,
    cardWrapper,
    cardSlide,
    cardspinnerWrapper,
    cardspinnerSlide,
    cardspinnerDskWrapper,
    cardspinnerDskSlide
  ) {
    fetch(`${productUrl}/section?id=main-content-product`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productSection = doc.querySelector('section[id^="MainProduct-"]');
        if (productSection) {
          infoElement.innerHTML = productSection.innerHTML;
          this.updateInputAndLabelAttributes(infoElement);
          if (infoElement.closest('.quick-add-slide')) {
            infoElement.closest('.quick-add-custom__info').classList.add('open-quick-add-slide');
          }

          if (window.innerWidth <= 749) {
            const quickAddInfo = infoElement.closest('.quick-add-custom__info');
            document.body.appendChild(quickAddInfo);
            document.body.classList.add('overflow-hidden');
          }

          const quickMoreInfoContainers = document.querySelectorAll('.product-quick-more_info-container');
          quickMoreInfoContainers.forEach((quickMoreInfoContainer) => {
            if (quickMoreInfoContainer) {
              quickMoreInfoContainer.href = productUrl;
            }
          });

          const tabSelectVariant = document.querySelectorAll(
            '.quick-add-custom__info .product-form__variant-tab .product-form__variant-tab-select'
          );
          if (tabSelectVariant.length) {
            tabSelectVariant.forEach((tabSelectitem) => {
              tabSelectitem.addEventListener('click', () => {
                tabSelectVariant.forEach((tab) => tab.classList.remove('tab-active'));
                tabSelectitem.classList.add('tab-active');

                const dataTab = tabSelectitem.getAttribute('data-tab-select');
                const parentNodeTabSelect = tabSelectitem.closest('.product-form__variant');
                if (window.NewcopSizeSystem) {
                  window.NewcopSizeSystem.set(dataTab);
                }

                parentNodeTabSelect.querySelectorAll('.label-variant-box').forEach((labelVariant) => {
                  const showVariantClass = `variant-${dataTab}`;
                  const hideVariantClass = `variant-${dataTab === 'eu' ? 'us' : 'eu'}`;

                  labelVariant.querySelector(`.variant-label.${showVariantClass}`).classList.remove('hidden');
                  labelVariant.querySelector(`.variant-label.${hideVariantClass}`).classList.add('hidden');
                });
              });
            });
          }
          let buyButtonsForm = '';
          if (this.querySelector('.buy-buttons__form-custom')) {
            buyButtonsForm = this.querySelector('.buy-buttons__form-custom');
          } else {
            if (window.innerWidth <= 749) {
              buyButtonsForm = document
                .querySelector('body>.quick-add-custom__info')
                ?.querySelector('.buy-buttons__form-custom');
            } else {
              buyButtonsForm = this.closest('.quick-add-slide')?.querySelector('.buy-buttons__form-custom');
            }
          }

          const handleQuickAddClickCard = () => {
            const anyChecked = Array.from(document.querySelectorAll('.product-variant-size-container input')).some(
              (input) => input.checked
            );
            if (!anyChecked) {
              document.querySelector('.product-variant-size-container')?.classList.add('select-size');
            }
          };

          const updateClassesCard = () => {
            const anyChecked = Array.from(document.querySelectorAll('.product-variant-size-container input')).some(
              (input) => input.checked
            );
            if (!anyChecked) {
              buyButtonsForm?.classList.remove('hidden');
            } else {
              buyButtonsForm?.classList.add('hidden');
            }
          };

          if (document.querySelectorAll('.quick-add-custom__info .product-variant-size-container input').length) {
            document
              .querySelectorAll('.quick-add-custom__info .product-variant-size-container input')
              .forEach((inputVariant) => {
                inputVariant.addEventListener('change', () => {
                  document
                    .querySelector('.quick-add-custom__info .product-variant-size-container')
                    ?.classList.remove('select-size');
                  const isFastShipping = inputVariant.hasAttribute('variant-fast-ship-input');
                  document
                    .querySelector('.quick-add-custom__info .product-info-delivery')
                    .classList.toggle('fast-shipping', isFastShipping);
                  document
                    .querySelector('.quick-add-custom__info .product-info-delivery')
                    .classList.toggle('normal-shipping', !isFastShipping);
                  updateClassesCard();
                });
              });
          }

          updateClassesCard();
          buyButtonsForm?.addEventListener('click', handleQuickAddClickCard);

          if (document.querySelector('.quick-add-custom__info .product-variant-size-container')) {
            const getPositionVariantPDP = document
              .querySelector('.quick-add-custom__info .product-variant-size-container')
              .getBoundingClientRect();
            const positionVariantPDP = getPositionVariantPDP.top + window.scrollY - 200;

            const stickySubmitBtn = document.querySelector(
              '.quick-add-custom__info .product-sticky-btn__button-submit'
            );
            if (stickySubmitBtn) {
              stickySubmitBtn.addEventListener('click', () => {
                stickySubmitBtn.classList.add('sticky-disabled');

                const isVariantChecked = Array.from(
                  document.querySelectorAll('.quick-add-custom__info .product-variant-size-container input')
                ).some((inputVrt) => inputVrt.checked);
                if (isVariantChecked) {
                  document.querySelector('.quick-add-custom__info .product-form__buttons button')?.click();
                  setTimeout(() => {
                    document.querySelector('.quick-add-custom__info.open-quick-add-slide .close-model').click();
                    stickySubmitBtn.classList.remove('sticky-disabled');
                  }, 500);
                } else {
                  stickySubmitBtn.classList.remove('sticky-disabled');
                  buyButtonsForm?.click();
                }
              });
            }
          }
          this.popupInfoDelivery();
          setTimeout(() => {
            cardWrapper?.classList.remove('open-quick-model');
            cardspinnerWrapper?.classList.add('hidden');
            cardspinnerSlide?.classList.add('hidden');
            cardspinnerDskWrapper?.classList.add('hidden');
            cardspinnerDskSlide?.classList.add('hidden');
            cardSlide?.classList.remove('cart-slide-quick-open');
            if (!cardSlide) {
              infoElement.closest('.quick-add-custom__info').setAttribute('style', `visibility: inherit;`);
            }
            infoElement
              ?.closest('.product-card-wrapper')
              ?.setAttribute('style', `padding-bottom: ${infoElement.offsetHeight + 144}px;`);

            const mediaGalleryElement = infoElement.querySelector('media-gallery');
            if (window.mediaGalleryElement) {
              new MediaGallery(mediaGalleryElement);
            } else {
              console.warn('MediaGallery not found');
            }
          }, 200);
          document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
        }
      })
      .catch((error) => {
        console.error('Error fetching product content:', error);
        infoElement.innerHTML = '<p>Error loading product information.</p>';
      });
  }

  popupInfoDelivery() {
    const infoDelivery = document.querySelectorAll('.product-info-delivery__shipping-time');

    infoDelivery.forEach((infoDeliveryitem) => {
      const deliveryContentContainer = infoDeliveryitem.closest('.product-info-delivery__content');
      const deliveryPopupContent = deliveryContentContainer.querySelector('.product-info-delivery__popup');
      const originalParent = deliveryPopupContent.parentNode;

      infoDeliveryitem.addEventListener('click', () => {
        const isOpen = deliveryContentContainer.classList.toggle('open');

        if (isOpen && window.innerWidth <= 749) {
          document.body.classList.add('overflow-hidden');
          document.body.appendChild(deliveryPopupContent);
        } else {
          document.body.classList.remove('overflow-hidden');
        }

        infoDelivery.forEach((otherInfoDeliveryitem) => {
          const otherDeliveryContent = otherInfoDeliveryitem.closest('.product-info-delivery__content');
          if (otherDeliveryContent !== deliveryContentContainer) {
            otherDeliveryContent.classList.remove('open');
            otherDeliveryContent.querySelector('.product-info-delivery__popup').classList.add('hidden');
          }
        });

        deliveryPopupContent.classList.toggle('hidden', !isOpen);
      });

      const deliveryClosePopup = deliveryContentContainer.querySelector('.close-popup');
      deliveryClosePopup.addEventListener('click', closePopup);

      deliveryPopupContent.addEventListener('click', (event) => {
        if (event.target === deliveryPopupContent) {
          closePopup();
        }
      });

      function closePopup() {
        deliveryPopupContent.classList.add('hidden');
        deliveryContentContainer.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        originalParent.appendChild(deliveryPopupContent);
      }
    });
  }
  updateInputAndLabelAttributes(infoElement) {
    const inputs = infoElement.querySelectorAll('.product-variant-size-container input');
    const labels = infoElement.querySelectorAll('.product-variant-size-container input + label');

    inputs.forEach((input) => {
      const id = input.getAttribute('id');
      const form = input.getAttribute('form');

      if (id) {
        input.setAttribute('id', `${id}_quick_add`);
      }
      if (form) {
        input.setAttribute('form', `${form}_quick_add`);
      }
    });

    labels.forEach((label) => {
      const htmlFor = label.getAttribute('for');

      if (htmlFor) {
        label.setAttribute('for', `${htmlFor}_quick_add`);
      }
    });

    const priceElement = infoElement.querySelector('.price-main-product');
    if (priceElement) {
      const currentId = priceElement.getAttribute('id');
      if (currentId) {
        priceElement.setAttribute('id', `quick_${currentId}`);
      }
    }
    const priceElementSticky = infoElement.querySelector('.price-sticky-mb');
    if (priceElementSticky) {
      const currentIdSticky = priceElementSticky.getAttribute('id');
      if (currentIdSticky) {
        priceElementSticky.setAttribute('id', `quick_sticky_${currentIdSticky}`);
      }
    }
    const variantRadiosQuick = infoElement.querySelector('variant-radios');
    variantRadiosQuick?.classList.add('variant-radios-quick');
  }

  resetInfoElement(infoElement, cardWrapper, cardSlide) {
    infoElement.innerHTML = '';
    infoElement.closest('.product-card-wrapper')?.setAttribute('style', '');
    infoElement.closest('.quick-add-custom__info').setAttribute('style', '');
    infoElement.closest('.quick-add-custom__info').classList.remove('open-quick-add-slide');
    cardWrapper?.classList.remove('open-quick-model');
    cardSlide?.classList.remove('cart-slide-quick-open');
  }

  handleCloseModelClick(closeModelElement) {
    const cardWrapper = closeModelElement.closest('.card-wrapper');
    const cardSlide = closeModelElement.closest('.section-slide-items');
    let infoElement = closeModelElement
      .closest('.quick-add-custom__info')
      .querySelector('.quick-add-custom__info-content');

    if (infoElement) {
      infoElement.innerHTML = '';
      infoElement.closest('.product-card-wrapper')?.setAttribute('style', '');
      infoElement.closest('.quick-add-custom__info').setAttribute('style', '');
      infoElement.closest('.quick-add-custom__info').classList.remove('open-quick-add-slide');
      cardWrapper?.classList.remove('open-quick-model');
      cardSlide?.classList.remove('cart-slide-quick-open');
      cardSlide?.classList.remove('is-quick-open');
      document.body.classList.remove('overflow-hidden');

      if (window.innerWidth <= 749 && this.originalParent) {
        this.originalParent.appendChild(infoElement.closest('.quick-add-custom__info'));
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    if (!customElements.get('card-product-cs')) {
      customElements.define('card-product-cs', CardProductCS);
    }
  } catch (error) {
    console.error('Failed to register card-product-cs:', error);
  }
});
